module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/industry-04-ce7a9118c9167758ad11394277cacbb3.png";